import { Timestamp } from '@angular/fire/firestore';
import { GroupType } from './group.model';

export interface NoticeAttachment {
  name: string;
  path: string;
  url: string;
}

export interface Notice {
  id: string;
  title: string;
  description: string;
  imageUrl: string | undefined;
  attachments?: NoticeAttachment[];
  publishOn: Timestamp;
  removeAfter: Timestamp;
  memberType: string[];
  groupId: string;
  groupName: string;
  academicYear: number;
  noticeStatus: NoticeStatus;
  events?: {
    [eventId: string]: {
      date: Timestamp;
      name: string;
    }
  } | undefined;

  isGradeNotice: boolean;
  gradeId: string | undefined;
  gradeName: string | undefined;

  groupType: GroupType;
  createdBy: string;
  createdById: string;
  updatedBy: string;
  updatedById: string;
  created: Timestamp;
  modified: Timestamp;
}

export enum NoticeStatus {
  active = 'active',
  draft = 'draft',
  completed = 'completed',
}
